import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IGetTramitesBusqueda, ITramitesDisponibles} from '../shared/interfaces/configuracion';
import {Page, PaginationParams, QueryParam, Utils, API_URL} from "lib-base";


@Injectable({
  providedIn: 'root'
})
export class TipoTramiteService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tipo-tramite`;
  }

  getTramitesBusqueda(search: string, pagination: Omit<Required<PaginationParams>, 'sort'>, dependencias?: number[]): Observable<Page<IGetTramitesBusqueda>> {
    const url = `${this.baseUrl}/public/busqueda/${search}`;
    let params: QueryParam[] = [{key: 'size', value: pagination.size},
      {key: 'page', value: pagination.page},];

    if (dependencias && dependencias.length) params.push({key:'dependencias', value: dependencias});
    return this.http.get<Page<IGetTramitesBusqueda>>(Utils.createQueryParams(url, params));
  }

  getTramiteBusquedaByTipoTramiteIdAndDependenciaId(tipoTramiteId: number, dependenciaId: number): Observable<IGetTramitesBusqueda> {
    return this.http.get<IGetTramitesBusqueda>(`${this.baseUrl}/public/busqueda/${tipoTramiteId}/${dependenciaId}`);
  }

  getHojaDeVidaTramiteById(tipoTramiteId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/public/hoja-de-vida/${tipoTramiteId}`);
  }
  getAllTramitesDisponibles():Observable<ITramitesDisponibles[]> {
    return this.http.get<ITramitesDisponibles[]>(`${this.baseUrl}/public/tramites`);
  }

}
